module.exports = __webpack_public_path__ + "static/media/07d.7c390655.svg";